import { useEffect, useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import DataTableTicketShop from "../../ui/DataTableTicketShop";
import ClientService from "../../services/PosService/ClientService";
import { Alert, Snackbar } from "@mui/material";

const ClientsVenteDetails = ({ startLoading, stopLoading }) => {
  const [availableOrdersByClient, setAvailableOrdersByClient] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  useEffect(() => {
    startLoading();
    ClientService.getClientDetails(localStorage.getItem("idDetailsClientVente"))
      .then((response) => {
        if (response?.status == 200) {
          setAvailableOrdersByClient(response?.data?.success);
        } else if (response?.data?.error) {
          setErrorAlertText("error " + response?.data?.error);
        }
      })
      .catch((error) => {
        setErrorAlertText("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);

  const filterTableTicketsByClient = () => {
    if (
      availableOrdersByClient != null &&
      availableOrdersByClient?.orders != null &&
      availableOrdersByClient?.orders?.length > 0
    ) {
      return (
        <>
          <DataTableTicketShop tickets={availableOrdersByClient} />
        </>
      );
    }
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                <b>Clients Details</b>
              </h5>
              <br />
              <br />
              Prénom & Nom :{" "}
              <b>
                {availableOrdersByClient?.firstName || ""}{" "}
                {availableOrdersByClient?.lastName || ""}
              </b>
              <br />
              Email : <b>{availableOrdersByClient?.email || ""}</b>
              <br />
              Adresse : <b>{availableOrdersByClient?.address || ""}</b>
              <br />
              Numéro Telepone :{" "}
              <b>{availableOrdersByClient?.phoneNumber || ""}</b>
              <br />
              Ville <b>{availableOrdersByClient?.country || ""}</b>
            </div>
          </div>
        </div>
      </section>
      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicketsByClient()}</div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(ClientsVenteDetails);
